"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL PartnerService
 * The EMIL PartnerService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePartnerRelationRequestDtoRestRelationTypeSlugEnum = void 0;
exports.CreatePartnerRelationRequestDtoRestRelationTypeSlugEnum = {
    Parent: 'parent',
    Sibling: 'sibling',
    Married: 'married',
    ManagingDirector: 'managing_director',
    Subsidiary: 'subsidiary',
    SubAgent: 'sub-agent',
    Employee: 'employee',
    Other: 'other'
};
